import { useWindowDimensions } from "../../context/window-dimensions-context/WindowDimensions";
import { Props, getSizesFromProps } from "./DisplayOn.Parts";

/**
 * Conditionally renders its children based on the current window size.
 *
 * Pass one or more window size boolean props (e.g., small, medium, large, xlarge) to control which
 * window sizes should display the children.
 *
 * Example usage:
 *   <DisplayOn small>...</DisplayOn>
 *   <DisplayOn medium large>...</DisplayOn>
 *
 * @param {Props} props - component props
 * @returns children if the current window size matches ANY of the true props, otherwise null
 */
export const DisplayOn = ({ children, ...rest }: Props) => {
  const { size: windowSize } = useWindowDimensions();
  const sizes = getSizesFromProps(rest);

  if (!sizes.length && process.env.NODE_ENV !== "production")
    console.warn(
      "[DisplayOn]: No size props were provided. " +
        "This will cause the component to never render its children. " +
        "Provide at least one size prop (e.g., small, medium, large, xlarge).",
    );

  if (sizes.includes(windowSize)) return children;
  return null;
};
